const flexboxgrid = {
  // Defaults
  gridSize: 12, // columns
  gutterWidth: 2, // rem
  // outerMargin: 2, // rem
  mediaQuery: 'only screen',
  container: {
    sm: 46, // rem (736px)
    md: 61, // rem (976px)
    lg: 72 // rem (1152px‬)
  },
  breakpoints: {
    xs: 0,  // em
    sm: 48, // em (768px)
    md: 64, // em (1024px)
    lg: 75  // em (1200px‬)
  }
};

const theme = {
  colors: {
    primary: '#FFC509',
    secondary: '#1BD5E4',
    tertiary: '#F687B3',
    gray100: '#F7FAFC',
    gray200: '#EDF2F7',
    gray300: '#E2E8F0',
    gray400: '#CBD5E0',
    gray500: '#A0AEC0',
    gray600: '#718096',
    gray700: '#4A5568',
    gray800: '#2D3748',
    gray900: '#1A202C',
    white: '#FFFFFF',
    black: '#0D0D0D',

    green: '#1B5E57',
    yellow: '#FFC509',
    blue: '#5277a0',
    pink1: '#F9A0B4',
    pink2: '#FF3A66',
    grey1: '#DEDEDE',
    grey2: '#F2F2F2',
    grey3: '#F9F9F9',
    grey4: '#606060',
    red: '#EB1212'
  },
  flexboxgrid: flexboxgrid
};

export default theme;
